module.exports = __webpack_public_path__ + "static/media/r48_thumb_even.db05976d.webp";